// extracted by mini-css-extract-plugin
export default {"login-wrap":"login_login-wrap__P+lkh","login-inner-wrap":"login_login-inner-wrap__efxM1"};